import React, { useState, useEffect, useRef } from "react";
import { Col, Form, Row } from "react-bootstrap";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { getZReading } from "../../Helpers/apiCalls/reportsAPI";
import {
  formatDateNoTime,
  getRestoLogin,
  getRole,
  formatAmount,
  refreshPage,
  toastStyle,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";

import html2canvas from "html2canvas";
import "jspdf-autotable";
import { printBase64 } from "../../Helpers/apiCalls/paymentAPI";

export default function ZReading() {
  const role = getRole();
  const [inactive, setInactive] = useState(true);
  const [allData, setAllData] = useState({});
  const [otherDiscounts, setOtherDiscounts] = useState([]);
  const [mainDetails, setMainDetails] = useState({});
  const [cashLedgerData, setCashLedgerData] = useState([]);
  const [creditLedgerData, setCreditLedgerData] = useState([]);
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
  });
  // const [printHeader, setPrintHeader] = useState("Z Reading");
  const [isPrinting, setIsPrinting] = useState(false);

  // async function fetchReportView(type) {
  //   const response = await getZReading(
  //     type,
  //     filter.date_from,
  //     filter.date_to,
  //     getRestoLogin()
  //   );
  //   if (response.data) {
  //     setAllData(response.data.data);
  //     setMainDetails(response.data.data.reports);
  //     const tempDisc = response.data.data.reports.other_discount.map((row) => {
  //       let tempName;
  //       if (row.name?.toLowerCase() === "employee") {
  //         tempName = "Employee Disc";
  //       } else if (row.name?.toLowerCase() === "max senior/pwd") {
  //         tempName = "Max SR/PWD";
  //       } else if (row.name?.toLowerCase() === "open discount amount") {
  //         tempName = "Open Disc Amt";
  //       } else if (row.name?.toLowerCase() === "open discount rate") {
  //         tempName = "Open Disc Rate";
  //       } else {
  //         tempName = row.name;
  //       }
  //       return {
  //         ...row,
  //         name: tempName,
  //       };
  //     });
  //     setOtherDiscounts(tempDisc);
  //     // setOtherDiscounts(response.data.data.reports.other_discount);
  //     setCashLedgerData(
  //       response.data.data.cash_ledger.cash_ledgers === null
  //         ? []
  //         : response.data.data.cash_ledger.cash_ledgers
  //     );
  //     setCreditLedgerData(response.data.data.credit_ledger.credit_ledgers);
  //   }
  // }

  async function fetchReport(type) {
    const response = await getZReading(
      type,
      filter.date_from,
      filter.date_to,
      getRestoLogin()
    );
    if (response.data) {
      setAllData(response.data.data);
      setMainDetails(response.data.data.reports);
      setOtherDiscounts(response.data.data.reports.other_discount)
      setCashLedgerData(
        response.data.data.cash_ledger.cash_ledgers === null
          ? []
          : response.data.data.cash_ledger.cash_ledgers
      );
      setCreditLedgerData(response.data.data.credit_ledger.credit_ledgers);
      // if (type === "print") {
      //   setTimeout(() => {
      //     handleApiPrint();
      //   }, 1000);
      // }
    } else {
      setAllData({});
      setMainDetails({});
      setOtherDiscounts([]);
      setCashLedgerData([]);
      setCreditLedgerData([]);
    }
  }
  //handle for date filter
  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  // Initialized variable for ref print category
  const printRef = useRef();

  // Handle for export to pdf
  // const handleExportPDF = () => {
  //   const pdf = new jsPDF();
  //   if (printRef.current) {
  //     const content = printRef.current;
  //     html2canvas(content).then((canvas) => {
  //       const imgData = canvas.toDataURL("image/png");
  //       const imgWidth = 200; // Set the width of the image (A4 size)
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //       const x = (pdf.internal.pageSize.width - imgWidth) / 2;
  //       pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
  //       pdf.save(printHeader);
  //     });
  //   }
  // };

  const handleApiPrint = () => {
    if (printRef.current) {
      const element = printRef.current;
      element.style.width = "var(--receipt-width)";
      setIsPrinting(true);
      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        printBase64Data(imgData);
        toast.success("Processing...", {
          style: toastStyle(),
        });
      });
    }
  };

  async function printBase64Data(image) {
    const response = await printBase64(
      window.printer_name,
      image,
      "0",
      getRestoLogin(),
      "Daily Sales"
    );
    if (response.data) {
      refreshPage();
    }
    setIsPrinting(false);
  }

  useEffect(() => {
    fetchReport("print");
  }, [filter]);

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      <div
        className={`container bold-font ${
          role === "2" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col xs={8}>
            <h1 className="page-title-menu">DAILY SALES REPORT</h1>
          </Col>
          <Col xs={2}>
            <button
              className="category-new-export-btn"
              onClick={() => handleApiPrint()}
            >
              PRINT
            </button>
          </Col>
          <Col xs={2} className="d-flex justify-content-end mb-2">
            <button
              className="category-new-export-btn"
              onClick={(e) => {
                fetchReport("zcounter");
              }}
            >
              EOD
            </button>
            &nbsp;&nbsp;
          </Col>
          <hr />
        </Row>
        {(getRole() === "1" || getRole() === "7") && (
          <div className="my-2 px-4 PO-filters d-flex">
            <span className="me-4 align-middle mt-2"> DATE:</span>
            <Form.Control
              size="sm"
              type="date"
              name="date_from"
              className="date-filter me-3"
              onChange={handleFilter}
              value={filter.date_from}
            />
          </div>
        )}

        <div className="redo-x-z-reading-cont p-5">
          <Row ref={printRef}>
            <Col>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_address}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_min}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_sn}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.company_ptu_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.issued_date}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <strong>Daily Sales</strong>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>{formatDateNoTime(new Date(filter.date_from))}</label>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Gross Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.gross_sales ? mainDetails.gross_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Sales Net of Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.net_sales ? mainDetails.net_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.tax_sales ? mainDetails.tax_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Vat Exempt Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.vat_exempt_sales
                        ? mainDetails.vat_exempt_sales
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Zero-Rated</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.zero_rated ? mainDetails.zero_rated : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className=" print-text" xs={10}>
                  <label>Ave Bill/Guest</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.avg_bill_per_guest
                        ? mainDetails.avg_bill_per_guest
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className=" print-text" xs={10}>
                  <label>Ave Bill/Trans</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.avg_bill_per_transaction
                        ? mainDetails.avg_bill_per_transaction
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              {/* <Row>
                  <Col className=" print-text">
                    <label>Transaction Count</label>
                  </Col>
                  <Col className="d-flex justify-content-end  print-text">
                    <label>
                      {formatAmount(
                        mainDetails.transaction_count
                          ? mainDetails.transaction_count
                          : "0"
                      )}
                    </label>
                  </Col>
                </Row> */}
              <Row>
                <Col className=" print-text" xs={10}>
                  <label>Guest Count</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.guest_count ? mainDetails.guest_count : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Transaction Count</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.no_of_transactions
                        ? mainDetails.no_of_transactions
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Quantity</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_qty ? mainDetails.total_qty : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Subtotal Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.subtotal_discount
                        ? mainDetails.subtotal_discount
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total VAT Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      mainDetails.total_vat_exempt
                        ? mainDetails.total_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. of Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.no_of_cancelled_si
                        ? mainDetails.no_of_cancelled_si
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Amount Cancelled SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.amount_cancelled
                        ? mainDetails.amount_cancelled
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Senior Citizen Disc</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.s_citizen_disc
                        ? mainDetails.s_citizen_disc
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. Senior Citizen Disc</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.no_s_citizen_disc
                        ? mainDetails.no_s_citizen_disc
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>S. Citizen Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.s_citizen_vat_exempt
                        ? mainDetails.s_citizen_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>PWD Disc</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.pwd_disc ? mainDetails.pwd_disc : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. PWD Disc</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.no_pwd_disc ? mainDetails.no_pwd_disc : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>PWD Vat Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.pwd_vat_exempt
                        ? mainDetails.pwd_vat_exempt
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              {otherDiscounts.map((data) => (
                <>
                  <Row>
                    <Col className=" print-text" xs={10}>
                      <Row>
                        <label>{data.name}</label>
                        <label>No. {data.name}</label>
                      </Row>
                    </Col>
                    <Col
                      className="d-flex justify-content-end text-right print-text"
                      xs={2}
                    >
                      <Row>
                        <label>
                          {parseFloat(
                            data.total_discount > 0 ? data.total_discount : 0.0
                          ).toFixed(2)}
                        </label>

                        <label>
                          {data.no_of_discount ? data.no_of_discount : 0}
                        </label>
                      </Row>
                    </Col>
                  </Row>
                </>
              ))}
              <Row>
                <Col className=" print-text" xs={10}>
                  <label>Total Service Charge</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_service_charge
                        ? mainDetails.total_service_charge
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Vat</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.expanded_value_added_tax
                        ? mainDetails.expanded_value_added_tax
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>No. Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.no_expanded_value_added_tax
                        ? mainDetails.no_expanded_value_added_tax
                        : "0"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Card Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_card ? mainDetails.total_card : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Foodpanda Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_foodpanda
                        ? mainDetails.total_foodpanda
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Grab Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_grab ? mainDetails.total_grab : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Gcash Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_gcash ? mainDetails.total_gcash : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Maya Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_maya ? mainDetails.total_maya : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className=" print-text" xs={10}>
                  <label>Total Charge Sales</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_charge
                        ? mainDetails.total_charge
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Total Coupon</label>
                </Col>
                <Col className="d-flex justify-content-end  print-text" xs={2}>
                  <label>
                    {formatAmount(
                      mainDetails.total_coupon
                        ? mainDetails.total_coupon
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text ms-2" xs={10}>
                  <label>Cash Ledger</label>
                </Col>
                {cashLedgerData?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text">
                        <label>{data.cashier}</label>
                      </Col>
                      <Col className="d-flex justify-content-end print-text">
                        <label>
                          {formatAmount(parseFloat(data.total_cash).toFixed(2))}
                        </label>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
              <Row>
                <Col className="print-text ms-2" xs={10}>
                  <label>Credit Ledger</label>
                </Col>
                {creditLedgerData?.map((data) => {
                  return (
                    <Row className="ms-3">
                      <Col className="print-text">
                        <label>{data.cashier}</label>
                      </Col>
                      <Col className="d-flex justify-content-end print-text">
                        <label>
                          {formatAmount(
                            parseFloat(data.total_credit).toFixed(2)
                          )}
                        </label>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
              <Row>
                <Col className="print-text" xs={10}>
                  <label>Media Summary</label>
                </Col>
              </Row>
              <Row className="print-text ms-4">
                <Col className="d-flex justify-content-left print-text" xs={5}>
                  <label>
                    Cash :{" "}
                    {allData.media_summary
                      ? formatAmount(
                          parseFloat(
                            allData.media_summary.media_summary.cash
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
                <Col className="d-flex justify-content-left print-text" xs={5}>
                  <label>
                    Credit :{" "}
                    {allData.media_summary
                      ? formatAmount(
                          parseFloat(
                            allData.media_summary.media_summary.credit
                          ).toFixed(2)
                        )
                      : "0.00"}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Beg. SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>{allData.beg_si}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>End SI</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>{allData.end_si}</label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Prev. Total</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      mainDetails.prev_grand_accumulated_total
                        ? mainDetails.prev_grand_accumulated_total
                        : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col className="print-text">
                  <label>Current Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      mainDetails.gross_sales ? mainDetails.gross_sales : "0.00"
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text bold-text">
                  <label>Running Totals:</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  {/* <label>
                    {formatAmount(
                      mainDetails.running_sales_net_of_discount ? mainDetails.running_sales_net_of_discount : "0.00"
                    )}
                  </label> */}
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>New Grand Total</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.new_total ? mainDetails.new_total : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Sales Net of Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_sales_net_of_discount ? mainDetails.running_sales_net_of_discount : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Vatable Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_vat_sales ? mainDetails.running_vat_sales : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>VAT Exempt Sales</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_vat_exempt_sales ? mainDetails.running_vat_exempt_sales : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total Discount</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_total_discount ? mainDetails.running_total_discount : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>VAT Exempt</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_vat_exemp ? mainDetails.running_vat_exemp : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <Row>
                <Col className="print-text">
                  <label>Total VAT</label>
                </Col>
                <Col className="d-flex justify-content-end print-text">
                  <label>
                    {formatAmount(
                      parseFloat(
                        mainDetails.running_total_vat ? mainDetails.running_total_vat : "0.00"
                      ).toFixed(2)
                    )}
                  </label>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_name}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text smaller-text">
                  <label>{window.myt_address1}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_address2}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_vat_reg_tin}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label> {window.myt_acc_no}</label>
                </Col>
              </Row>
              <Row>
                <Col className="text-center print-text">
                  <label>{window.myt_issued_date}</label>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
